import { PlessViewUtilsSub } from './../../../kymw00/pless-view-utils-sub.service';
import { KYMW0500Model } from '../kymw0500.model';
import { GetRelatedDataModel } from '../vo/get-related-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 紐付設定画面のデータを取得する
 *
 * @export API通信成功時の処理
 * @class GetRelatedDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetRelatedDataService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW0500Model;
  private vo: GetRelatedDataModel;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetRelatedDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProcessDiv: this.vo.processDiv,
        OrderCode: this.vo.orderCode,
        PCode: this.vo.mainPCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW0500Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetRelatedDataService
   */
  execute(model: KYMW0500Model, vo: GetRelatedDataModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.send('getRelatedData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetRelatedDataService
   */
  success(data: any) {
    // 取得した紐付設定画面データを反映する
    this.model.setRelatedData(data);
    // 排他ロックを行う
    this.model.lockPCodeList = new Array<any>();
    for (const vo of this.model.relatedDataList) {
      if (!PlessViewUtilsSub.isEmpty(vo.pCode)) {
        this.model.lockPCodeList.push(vo.pCode);
      }
    }
    if (this.model.processDiv === '1' ||
      !this.model.editMode) {
      this.model.kymw0500Component.lockOK_Init();
    } else {
      // 商品企画マスタの排他ロックを行う
      this.model.kymw0500Component.LockUtilForPlanGoods('REGIST',
        this.model.orderCode,
        this.model.mediumType,
        this.model.lockPCodeList,
        (event: any) => {
          this.model.kymw0500Component.lockOK_Init();
        },
        null,
        (event: any, result: any): void => {
          this.model.kymw0500Component.lockErr_Init({ event, result });
        },
        null,
        false);
    }
  }
}